import { useEffect, useState } from "react";

import { useSelector } from "react-redux";

import LeadingFoldersPanelInfoContainer from "app/pages/website-analysis/website-content/leading-folders/components/LeadingFoldersPanelInfoContainer";
import { EPageIdOption, SegmentsUpsaleBanner } from "app/pages/segments/upsale-banner/SegmentsUpsaleBanner";
import { proNavigator } from "single-spa/react-app/ProNavigator";
import { EMPTY_CUSTOM_SEGMENTS } from "app/services/segments/segmentsApiService";
import { SegmentsUtils } from "app/services/segments/SegmentsUtils";

import FoldersTable from "./components/FoldersTable/FoldersTable";
import LobFoldersBanner from "./components/LobFoldersBanner/LobFoldersBanner";
import { useLobBanner } from "./hooks/useLobBanner";

export const Folders = () => {
    const { mainSite, shouldShowLobBanner, handleCloseLobBanner } = useLobBanner();

    const customSegmentsMeta = useSelector((state) => {
        const {
            segmentsModule: { customSegmentsMeta: segmentsMeta = EMPTY_CUSTOM_SEGMENTS },
        } = state;
        return segmentsMeta;
    });
    const doSegmentsExist =
        SegmentsUtils.doSegmentsExistInAccount(customSegmentsMeta) || SegmentsUtils.doSegmentsExistInUserData();
    const [displaySegmentsUpsaleBanner, setDisplaySegmentsUpsaleBanner] = useState(false);
    const isBannerVisible = proNavigator.current().viewConfig?.hideBanner !== true;

    useEffect(() => {
        setDisplaySegmentsUpsaleBanner(!doSegmentsExist);
    }, [doSegmentsExist]);

    const handleCloseSegmentsBanner = () => {
        setDisplaySegmentsUpsaleBanner(false);
    };

    return (
        <>
            {isBannerVisible ? (
                <SegmentsUpsaleBanner
                    isTopBanner
                    pageId={EPageIdOption.FOLDERS_ANALYSIS}
                    isVisible={displaySegmentsUpsaleBanner}
                    closeBanner={handleCloseSegmentsBanner}
                />
            ) : null}
            {shouldShowLobBanner ? (
                <LobFoldersBanner
                    mainSite={mainSite}
                    onClose={handleCloseLobBanner}
                />
            ) : null}
            <LeadingFoldersPanelInfoContainer />
            <FoldersTable />
        </>
    );
};
